import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/laceData';

export default function FeaturedArticles() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="mx-auto" style={{ maxWidth: '1280px' }}>
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-primary-500 text-sm tracking-[0.2em] uppercase mb-2 font-label">Featured Articles</p>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900">
              精选文章
            </h2>
          </div>
          <Link
            to="/category/lace-fabric-types"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            浏览全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-primary-500 bg-primary-100 px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}